import type { Goal } from "instantdb/types";

export const FITNESS_GOALS: Partial<Goal>[] = [
  {
    id: "build-running-habit",
    symbol: "🏃‍♂️",
    title: "Build Running Habit",
    description: "Start running regularly and gradually increase your distance",
  },
  {
    id: "build-strength-safely",
    symbol: "🏋️‍♂️",
    title: "Build Strength Safely",
    description: "Learn proper form and gradually increase your strength",
  },
  {
    id: "build-healthy-habits",
    symbol: "💪",
    title: "Build Healthy Habits",
    description: "Develop sustainable habits for better health and fitness",
  },
];
